import app from 'flarum/forum/app';
/**
 * "Nouvelle discussion" on a page that isn't a forum's own but lists one
 * category's discussions - champis-keys' DeterminationKeysPage,
 * champis-others' BooksPage/LinksPage, champis-species' DescriptionsPage:
 * the composer, with that category preselected like a forum page does (a
 * guest gets the log-in modal instead). Without `tagSlug`, none - the
 * category picker then opens (see chooseCategoryOnNewDiscussion.ts).
 *
 * The category with its whole ancestor chain (e.g. Rédactions > Liens >
 * Sites généralistes), as the picker selects it (see categorySelect.tsx),
 * set before the composer shows - or the picker would open meanwhile.
 *
 * Reached by those extensions through flarum.reg (see index.ts), at click
 * time.
 */
export default function startDiscussion(tagSlug) {
  const user = app.session.user;
  if (!user) {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
    return;
  }

  // Usually already loaded: resolves at once.
  app.tagList.load(['parent']).then(() => {
    const tags = [];
    for (let tag = tagSlug ? app.store.getBy('tags', 'slug', tagSlug) : undefined; tag; tag = tag.parent() || undefined) {
      tags.unshift(tag);
    }
    app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
      user
    }).then(loaded => {
      // Nothing loaded when its author kept the draft already open
      // (ComposerState.preventExit()'s confirm): leave that one alone.
      if (!loaded) return;
      app.composer.fields.tags = tags;
      app.composer.show();
    });
  });
}
flarum.reg.add('champis-forum', 'forum/utils/startDiscussion', startDiscussion);